// const carouselContExists = document.querySelector(`#testimonials`);

const testimonialCardsCarousel = document.querySelector(
  `#testimonialCardCarousel`
);

if (testimonialCardsCarousel) {
  const testimonialTrack = document.querySelector(".testimonial-track");

  const testimonialControlNext = document.querySelector(
    ".testimonial-control-next"
  );

  const testimonialControlPrev = document.querySelector(
    ".testimonial-control-prev"
  );

  /**
   * Slides the card from the front of the deck to the back of the pile.
   * Applies classes to control the animation of the slide movement.
   * @param {*} cards
   */
  const slideNext = (cards) => {
    let childCards = [...cards.children];
    middleCards = childCards.slice(1);
    moveDirection = "up";
    activeCard = childCards[0];
    moveToLast = activeCard.cloneNode(true);

    activeCard.classList.add("move-to-end");

    moveMiddleCards(middleCards, moveDirection);

    setTimeout(() => {
      childCards[0].classList.remove("move-to-end");
      childCards[0].classList.add("slide-behind");
    }, 400);

    setTimeout(() => {
      moveToLast.classList.remove("moving-to-end");
      moveToLast.classList.remove("active");

      childCards.shift();
      childCards.push(moveToLast);
      childCards[0].classList.add("active");

      cards.removeChild(activeCard);
      cards.replaceChildren(...childCards);
    }, 800);
  };

  /**
   * Slides the card from the back of the deck to the top of the pile.
   * Applies classes to control the animation of the slide movement.
   * @param {*} cards
   */
  const slidePrev = (cards) => {
    let childCards = [...cards.children];
    middleCards = childCards.slice(0, childCards.length - 1);
    moveDirection = "down";

    lastCard = childCards[childCards.length - 1];
    moveToActive = lastCard.cloneNode(true);

    lastCard.classList.add("move-to-start");

    moveMiddleCards(middleCards, moveDirection);

    setTimeout(() => {
      lastCard.classList.remove("move-to-start");
      lastCard.classList.add("slide-front");
    }, 400);

    setTimeout(() => {
      lastCard.classList.remove("slide-front");
      childCards[0].classList.remove("active");
      childCards.pop();
      childCards.unshift(moveToActive);
      moveToActive.classList.add("active");

      cards.removeChild(lastCard);
      cards.replaceChildren(...childCards);
    }, 800);
  };

  /**
   * Applies moving class to the middle cards in the deck.
   * @param {*} cards
   * @param {*} direction
   */
  const moveMiddleCards = (cards, direction) => {
    cards.forEach((card) => {
      card.classList.add(`moving-${direction}`);
      setTimeout(() => {
        card.classList.remove(`moving-${direction}`);
      }, 800);
    });
  };

  if (testimonialCardsCarousel) {
    /**
     * Event Listener that moves the next card in the deck.
     * Disables button input until the timeout finsihes.
     * This allows the animations to run uninterrupted.
     */
    testimonialControlNext.addEventListener("click", () => {
      testimonialControlNext.disabled = true;
      slideNext(testimonialTrack);
      setTimeout(() => {
        testimonialControlNext.disabled = false;
      }, 800);
    });

    /**
     * Event Listener that moves the prev card in the deck.
     * Disables button input until the timeout finsihes.
     * This allows the animations to run uninterrupted.
     */
    testimonialControlPrev.addEventListener("click", () => {
      testimonialControlPrev.disabled = true;
      slidePrev(testimonialTrack);
      setTimeout(() => {
        testimonialControlPrev.disabled = false;
      }, 800);
    });
  }

  /**
   * Make each testimonial visible offscreen briefly to determine the height
   */
  const determineHeightOfAHiddenDivElement = (elem) => {
    elem.style.height = ``;
    elem.style.position = `absolute`;
    elem.style.top = `-5000px`;
    elem.style.display = `block`;
    const height = elem.clientHeight;
    elem.style.display = ``;
    elem.style.top = ``;
    elem.style.position = ``;
    return height;
  };

  /**
   * Assign the heights of each testimonial to an array for evaluation
   */
  const setMaxHeightValue = (items) => {
    let carouselItemHeights = [];

    items.forEach((item) => {
      let height = determineHeightOfAHiddenDivElement(item);
      carouselItemHeights.push(height);
    });

    var maxValueInArray = Math.max.apply(Math, carouselItemHeights);
    return maxValueInArray;
  };

  const applyCardHeights = (cards, track) => {
    maxHeight = setMaxHeightValue(cards);
    cards.forEach((card) => {
      card.style.height = maxHeight + 30 + `px`;
    });
    track.style.height = maxHeight + 30 + `px`;
  };

  /**
   * If Carousel exists determine the height of the biggest elem
   * and assign that to the craousel track
   */

  const testimonialItems = document.querySelectorAll(
    `.testimonial-track .testimonial-item`
  );

  applyCardHeights(testimonialItems, testimonialTrack);

  /**
   * Resize the cards and track if the window size changes
   */
  let resized;
  window.addEventListener(`resize`, () => {
    clearTimeout(resized);
    resized = setTimeout(() => {
      applyCardHeights(testimonialItems, testimonialTrack);
    }, 100);
  });
}
